import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// 单点登录地址
const SSO_ADDRESS = 'https://sso.huamengtech.com/?sys_code=HMSYS101&response_type=code&redirect_uri=https%3A%2F%2Fnewtaxera.huamengtech.com%2Flogin%3Fredirect%3D%2Fhome'
// 法规库生产地址
const LAW_URL = 'https://regulatory.huamengtech.com/'
// 法规库申请账号url
const LAW_APPLY_URL = 'https://sso.huamengtech.com/lawapply'
// 英文,日文版网站地址
const OLD_WEB_SITE_URL_MAP = {
  'huamengtech.com': 'https://global.huamengtech.com/',
  'www.huamengtech.com': 'https://global.huamengtech.com/',
  'localhost': 'http://www-uat-old.huamengtech.net/'
}

export default new Vuex.Store({
  state: {
    langue: '',
    showContact: false, // 打开联系我们弹窗
    isH5: false, // 是否为移动端, 默认pc端
    showAreaIcon: true, // 是否展示全屏的icon
    SSO_ADDRESS,
    LAW_URL,
    LAW_APPLY_URL
  },
  mutations: {
    SET_LANGUE (state, langue) {
      state.langue = langue
    },
    SET_SHOWAREAICON (state, value) {
      state.showAreaIcon = value
    },
    SET_SHOWCONTACT (state, value) {
      state.showContact = value
    },
    SET_ISH5 (state, value) {
      state.isH5 = value
    }
  },
  actions: {
    setShowAreaIcon ({ commit }, langue) {
      commit('SET_SHOWAREAICON', langue)
    },
    setLangue ({ commit }, langue) {
      commit('SET_LANGUE', langue)
    },
    setShowContact ({ commit }, value) {
      commit('SET_SHOWCONTACT', value)
    },
    setIsH5 ({ commit }, flag) {
      commit('SET_ISH5', flag)
    }
  },
  getters: {
    langue: state => state.langue,
    showAreaIcon: state => state.showAreaIcon,
    showContact: state => state.showContact,
    isH5: state => state.isH5,
    SSO_ADDRESS: state => state.SSO_ADDRESS,
    LAW_URL: state => state.LAW_URL,
    LAW_APPLY_URL: state => state.LAW_APPLY_URL,
    OLD_WEB_SITE_URL: state => {
      const hostname = window.location.hostname
      const target = OLD_WEB_SITE_URL_MAP[hostname] || 'https://global.huamengtech.com/'
      return target
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js